import * as React from 'react';
import * as types from 'modules/types/smSupplierManagement';
import { Form, Card } from '@beehive/components';
import { DotDotDotPopover} from 'components';
import { renderDefault, isBlank } from 'utils';
import { SERVICE_INFO_KEYS } from '../utils';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import messages from 'messages/CompanyManagement';
import _ from 'lodash';

export const getCurValue = (value: string): string => {
  return isBlank(value) ? '--' : value;
};

export type ServiceInfoProps = {
  serviceInfoKeys?: any;
} & types.SupplierMangementDetail;

const ServiceInfo: React.SFC<ServiceInfoProps> = (props, context) => {
  const { intl } = context;
  const { service_info = {}, loading, serviceInfoKeys = SERVICE_INFO_KEYS } = props;
  const dirtyAttrs: any[] = _.get(props, 'dirty_attrs.service_info', []);
  const dirtyAttrsSupplierResources: boolean = _.get(props, 'dirty_attrs.supplier_resources', false);

  return (
    <Card
      titleNode={intl.formatMessage(messages.serviceInfo)}
      className="service-info-show"
      loading={loading}
    >
      <Form isLabelVertical>
        {
          Object.keys(serviceInfoKeys).map((key, index) => {
            const serviceItem = SERVICE_INFO_KEYS[key];
            const label = intl.formatMessage(messages[key]);
            const serviceProps = serviceItem.showProps || {};
            const container = serviceProps.render
              ? serviceProps.render(props)
              : renderDefault(service_info[key]);
            let prefixCls = '';
            if (dirtyAttrs.includes(key)) {
              prefixCls = 'service-info-show-dot-popover';
            }
            return (
              <Form.Item
                label={label}
                key={key}
                className={classnames(key, {
                  ['color-red']: dirtyAttrs.includes(key) ||
                    (key === 'supplier_resources' && dirtyAttrsSupplierResources),
                })}
                {...serviceProps}
              >
                <span >
                  <DotDotDotPopover value={container} prefixCls={prefixCls} />
                </span>
              </Form.Item>
            );
          })
        }
      </Form>
    </Card>
  );
};

ServiceInfo.contextTypes = {
  intl: PropTypes.object,
};

export default ServiceInfo;
